import { observer } from 'mobx-react-lite';
import { FC, RefObject } from 'react';

import { PopoverMenu } from '@gem/ui-kit';

import FileUploadButton from '../FileUploadButton';
import { useAttachmentsButtonMenuPresenter } from './AttachmentsButtonMenu.presenter';
import styles from './AttachmentsButtonMenu.styles.m.css';

interface IAttachmentsButtonMenuProps {
  isOpened: boolean;
  onClose(): void;
  fileUploadRef: RefObject<FileUploadButton>;
  attachButtonRef: RefObject<HTMLButtonElement>;
}

export const AttachmentsButtonMenu: FC<IAttachmentsButtonMenuProps> = observer((props) => {
  const { isOpened, onClose, fileUploadRef, attachButtonRef } = props;
  const presenter = useAttachmentsButtonMenuPresenter(fileUploadRef);

  return (
    <PopoverMenu
      isOpened={isOpened}
      placement="top-start"
      menuItems={presenter.menuItems}
      reference={attachButtonRef.current}
      onClose={onClose}
      className={styles.container}
    />
  );
});
